module.exports = __webpack_public_path__ + "img/no-offers.f59b0890.png";